module.exports = __webpack_public_path__ + "assets/996d86197e8dfe616a0f010058b8638b.png";